<template>
  <div
    class="conv-block d-flex w-100 align-items-center justify-content-center mb-3 p-2 pt-3 pb-3 fz-14 fw-500"
    @click="gotoChat()"
  >
    <img v-if="data && data.icon" :src="data.icon" class="mr-2" />
    <div class="d-flex flex-column w-100 justify-content-center text-left">
      <span v-if="data && data.category" class="text-dark">{{
        $t(data.category)
      }}</span>
      <span class="mb-1 caption date fz-12">
        <span class="mr-1">{{ date }}</span>
        <span>{{ time }}</span>
      </span>
    </div>
    <div class="d-flex flex-column fz-12">
      <span v-if="status" class="text-center caption" :class="this.status">{{
        this.status
      }}</span>
      <span v-if="data && data.total > 0" class="total ml-auto">{{
        data.total
      }}</span>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      status: "",
      date: "",
      time: "",
    };
  },
  props: ["data"],
  methods: {
    getMessage: function (key) {
      return this.$t(key);
    },
    gotoChat() {
      this.$emit("goto-chat", {
        room_id: this.data.room_id,
        category_id: this.data.category_id,
      });
    },
  },
  mounted() {
    if (this.data && this.data.date) {
      // Get current language setting
      const currentLang = localStorage.getItem("lang") || "en";
      console.log("Current Language:", currentLang);

      // Set moment locale based on current language
      switch (currentLang) {
        case "ja-JA":
          moment.locale("ja");
          break;
        case "zh-CN":
          moment.locale("zh-cn");
          break;
        case "zh-TW":
          moment.locale("zh-tw");
          break;
        case "my-MY":
          moment.locale("ms"); // Malaysian locale
          break;
        default:
          moment.locale("en");
      }

      // Use localized date format
      this.date = moment(this.data.date).format("L"); // Localized date format
      this.time = moment(this.data.date).format("LTS"); // Localized time format with seconds
    }
    if (this.data && this.data.status !== undefined) {
      this.status =
        this.data.status == 1
          ? this.getMessage("Open")
          : this.getMessage("Closed");
    }
  },
};
</script>

<style scoped src="@/assets/css/chat.css"></style>
